import { Controller } from 'stimulus';

class LanguageSwitchController extends Controller {
  connect() {
    this.isOpen = false;
  }

  onToggleClick() {
    this.toggle(!this.isOpen);
  }

  onWindowClick({ target }) {
    if (target.closest('[data-target="language-switch.toggle"]') || target.closest('[data-target="language-switch.dropdown"]')) return;

    this.toggle(false);
  }

  toggle(state) {
    this.isOpen = state;

    this.element.classList.toggle('is-open', state);
    this.toggleTarget.setAttribute('aria-expanded', state ? 'true' : 'false');
  }
}

LanguageSwitchController.targets = [
  'toggle',
  'dropdown',
];

export default LanguageSwitchController;
